import styled from 'styled-components/macro'

const StepNav = styled.ol`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 1em 0;
  padding: 0;
  list-style: none;
`

export default StepNav

